"use client";
import React from "react";
import dynamic from "next/dynamic";
import {
    HOW_IT_WORKS,
    HOW_IT_WORKS_FIRST_ROW,
    HOW_IT_WORKS_SECOND_ROW,
    HOW_IT_WORKS_SECTION_BUTTON_ID_TEXT,
    HOW_WE_WORK_MAIN_CONTAINER,
    HOW_WE_WORK_STYLE_CLASS,
    HOW_WE_WORK_TITLE,
    HOW_WE_WORK_WRAPPER_CONTAINER,
} from "./constants";
import {
    ENGLISH,
    SIGN_UP_ENDPOINT,
    SURVEY_ENDPOINT,
    SURVEY_START_SECTIONS,
    WARDROBE_STYLING_ENDPOINT,
    ZERO,
} from "../../../public/Constants/EnumConstants";
import { PrismicRichText } from "@prismicio/react";
import NewPrimaryButtonWrapper from "../../Atoms/Buttons/NewPrimaryButtonWrapper";
import { GoogleTagManagerEvents } from "../../../common";
import HowWeWorksCard from "../../Molecules/HowWeWorksCard";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import { usePathname } from "next/navigation";
import useStore from "../../../lib/Store/useStore";

const HowWeWorkSection = ({ slice }) => {
    const route = usePathname();
    const { userData, flag } = useStore();

    if (flag !== "AE" && route == "/") return <></>;

    return (
        <div id={HOW_IT_WORKS} className={HOW_WE_WORK_WRAPPER_CONTAINER}>
            <div className={HOW_WE_WORK_MAIN_CONTAINER}>
                <div className={HOW_WE_WORK_STYLE_CLASS}>
                    <PrismicRichText
                        field={slice?.primary?.title}
                        components={{
                            heading1: ({ children }) => (
                                <p
                                    className={
                                        "font-libre font-normal text-xl sm:text-[32px] "
                                    }
                                >
                                    {children}
                                </p>
                            ),
                        }}
                    ></PrismicRichText>
                </div>
                <div className={HOW_IT_WORKS_FIRST_ROW}>
                    {slice?.items?.map((item, index) => (
                        <HowWeWorksCard
                            haveButton={slice?.primary?.button_text}
                            key={index}
                            index={index}
                            step={item?.index}
                            heading={item?.title}
                            description={item?.description}
                            subText={item?.sub_text}
                            image={item?.image}
                        />
                    ))}
                </div>

                {!slice?.primary?.button_text ? null : (
                    <div className={HOW_IT_WORKS_SECOND_ROW}>
                        {slice?.variation === "whatToExpect" ? (
                            <NewPrimaryButton
                                menuName={SURVEY_START_SECTIONS?.HowWeWorks}
                                event={
                                    GoogleTagManagerEvents.navigationInteractions
                                }
                                place={SURVEY_START_SECTIONS?.HowWeWorks}
                                text={slice?.primary?.button_text}
                                href={WARDROBE_STYLING_ENDPOINT}
                                section={SURVEY_START_SECTIONS?.HowWeWorks}
                                buttonId={HOW_IT_WORKS_SECTION_BUTTON_ID_TEXT}
                            />
                        ) : (
                            <NewPrimaryButtonWrapper
                                menuName={SURVEY_START_SECTIONS?.HowWeWorks}
                                event={
                                    GoogleTagManagerEvents.navigationInteractions
                                }
                                place={SURVEY_START_SECTIONS?.HowWeWorks}
                                text={slice?.primary?.button_text}
                                href={
                                    slice?.primary?.button_link || !userData
                                        ? SIGN_UP_ENDPOINT
                                        : SURVEY_ENDPOINT
                                }
                                section={SURVEY_START_SECTIONS?.HowWeWorks}
                                buttonId={HOW_IT_WORKS_SECTION_BUTTON_ID_TEXT}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default HowWeWorkSection;
